import React, { useState } from "react";
import { useContext } from "../../../context";
import { useAppointmentPaymentLinkQuery } from "../../../../../../../../../api/appointments/useAppointmentPaymentLinkQuery";
import { useResendAppointmentPaymentLinkMutation } from "../../../../../../../../../api/appointments/useResendAppointmentPaymentLinkMutation";
import { uiNotification } from "../../../../../../../../../services/UINotificationService";

/*
 * A held booking is only confirmed once the patient pays, and the link used to exist
 * only in the dialog shown at booking time. These actions fetch the live link from
 * Stripe so the staff can share or re-text it for as long as the hold lasts.
 */
export function PaymentLink() {
  const { id } = useContext();
  const [isCopied, setIsCopied] = useState(false);

  const { data, isFetching } = useAppointmentPaymentLinkQuery({
    appointmentId: id,
  });

  const { mutate: resend, isLoading: isResending } =
    useResendAppointmentPaymentLinkMutation({
      onSuccess: (response) => {
        if (response?.data?.data?.payment_link_sent) {
          uiNotification.success("Payment link texted to the patient");
        } else {
          uiNotification.error(
            "We could not text the payment link. Copy it and share it with the patient.",
          );
        }
      },
      onError: () => {
        uiNotification.error(
          "This hold is no longer open, so the link cannot be sent. Rebook the appointment.",
        );
      },
    });

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(data.paymentLink);
      setIsCopied(true);
    } catch (e) {
      uiNotification.error("Could not copy the payment link");
    }
  };

  /* nothing to offer while loading, or once the hold lapsed or was paid */
  if (!data?.paymentLink) {
    return null;
  }

  return (
    <>
      <button className="new-blue-btn" onClick={onCopy} disabled={isFetching}>
        {isCopied ? "Copied" : "Copy payment link"}
      </button>
      <button
        className="new-line-btn"
        onClick={() => resend({ appointmentId: id })}
        disabled={isResending || isFetching}
      >
        {isResending ? "Sending..." : "Text link again"}
      </button>
    </>
  );
}
